if (!customElements.get("nss-accordion")) {
    customElements.define("nss-accordion", class NSSAccordion extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: ".js-nss-accordion-toggle",
                content: ".js-nss-accordion-panel",
                moreBtn: ".js-nss-accordion-more",
            };

            this.toggles = this.querySelectorAll(this.selectors.toggle);
            this.contents = this.querySelectorAll(this.selectors.content);
            this.moreBtns = this.querySelectorAll(this.selectors.moreBtn);
            this.isSingleOpen = this.getAttribute("data-single-open");
            this.init();
        }

        init() {
            this.toggles.forEach(el => {
                el.addEventListener('click', () => {
                    this.handleToggleClick(el);
                });
            });
            this.moreBtns.forEach(el => {
                el.addEventListener('click', () => {
                    this.classList.add("is-show-all");
                });
            });
        }

        handleToggleClick(toggle) {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            const contentId = toggle.getAttribute('aria-controls');
            const content = this.querySelector(`#${contentId}`);
            if (this.isSingleOpen == true) {
                // Collapse all toggles and panels
                this.resetAccordion();
            }
            // Expand the clicked toggle and its corresponding content if it was not already expanded
            if (!isExpanded) {
                toggle.setAttribute('aria-expanded', 'true');
                content.classList.add('is-open');
            }else{
                toggle.setAttribute('aria-expanded', 'false');
                content.classList.remove('is-open');
            }
        }

        resetAccordion() {
            // Collapse all toggles and panels
            this.toggles.forEach(toggle =>
                toggle.setAttribute('aria-expanded', 'false')
            );
            this.contents.forEach(content =>
                content.classList.remove('is-open')
            );
        }
    });
}